import works from "./Works.module.css";
import LeftWorkCard from "../../components/workcard/LeftWorkCard";
import RightWorkCard from "../../components/workcard/RightWorkCard";
import ShrunkWorkCard from "../../components/workcard/ShrunkWorkCard";
import projects from "../../data/WorksData";

function Works() {
    // Separate the projects into two arrays
    const mainProjects = projects.slice(0, 4);     // first 4 big cards
    const shrunkProjects = projects.slice(4);      // rest shrunk cards

    return (
        <main id="works" className={works.works}>
            <h1 className={works.h1}>WORKS</h1>

            {/* Original container for first 4 cards */}
            <div className={works.cards}>
                {mainProjects.map((project, index) =>
                    index % 2 === 0 ? (
                        <LeftWorkCard
                            key={index}
                            img={project.img}
                            h1={project.h1}
                            p={project.p}
                            time={project.time}
                            tags={project.tags}
                            linkTo={project.linkTo}
                        />
                    ) : (
                        <RightWorkCard
                            key={index}
                            img={project.img}
                            h1={project.h1}
                            p={project.p}
                            time={project.time}
                            tags={project.tags}
                            linkTo={project.linkTo}
                        />
                    )
                )}
            </div>

            {/* New container for shrunk cards */}
            <div className={works.shrunkCardsContainer}>
                {shrunkProjects.map((project, index) => (
                    <ShrunkWorkCard
                        key={index + 4} // to keep unique keys
                        img={project.img}
                        h1={project.h1}
                        linkTo={project.linkTo}
                    />
                ))}
            </div>
        </main>
    );
}

export default Works;
